export default {
  methods: {
    mixPanelUserLogin(response) {
      console.log('mixPanelUserLogin', response)
      // eslint-disable-next-line no-undef
      mixpanel.identify(response.loggedUserId);
      // eslint-disable-next-line no-undef
      mixpanel.people.set_once({
          "First Login": new Date().toISOString(),
      });

      // eslint-disable-next-line no-undef
      mixpanel.track("Login", { "Login Method": "Email", "Login Platform": this.$getPlatform(), "Login client": "Webapp" });

      // eslint-disable-next-line no-undef
      mixpanel.register({
          "email": response.email,
          "name": response.name,
      });

      // eslint-disable-next-line no-undef
      mixpanel.people.set({ "$email": response.email, "$name": response.name });
      // eslint-disable-next-line no-undef
      mixpanel.identify(response.loggedUserId);

      //desactivat pk ho hem posat al servidor.
      // eslint-disable-next-line no-undef
      mixpanel.people.increment('Total logins');
      // eslint-disable-next-line no-undef
      mixpanel.people.set({ "Last Login": new Date().toISOString() });


      // eslint-disable-next-line no-undef
      mixpanel.people.set_once({
          '# of Searches': 0,
          'Total share': 0,
          'Total Add': 0
      });

      // Session Replay puntual para la campaña DE (baby-wunschliste-v2):
      // solo arranca si esta pestaña viene de esa landing y no se ha
      // grabado ya a este usuario/navegador antes (ver LandingBabyWunschlisteDE.vue).
      try {
        const replaySource = sessionStorage.getItem('mp_replay_source');
        if (replaySource && !localStorage.getItem('mp_replay_recorded')) {
          // Texto e imágenes visibles en este replay puntual (los inputs
          // siguen enmascarados por defecto, y password/email/tel siempre
          // se enmascaran pase lo que pase, eso no lo controla esta config).
          // eslint-disable-next-line no-undef
          window.mixpanel?.set_config?.({
            record_mask_all_text: false,
            record_block_selector: '',
          });
          // eslint-disable-next-line no-undef
          window.mixpanel?.start_session_recording?.();
          localStorage.setItem('mp_replay_recorded', replaySource);
          sessionStorage.removeItem('mp_replay_source');
        }
      } catch (e) { /* storage no disponible */ }
    }
  }
}